import { keepPreviousData, skipToken, useQuery } from '@tanstack/react-query'
import {
  fetchFridge,
  fetchFridges,
  fetchSensor,
  fetchSensorHistory,
  fetchSensors,
  type FetchSensorHistoryParams,
} from '../queries/sensors.queries'

export const useSensors = (storeId?: number | null) =>
  useQuery({
    queryKey: ['sensors', storeId],
    queryFn: () => fetchSensors(storeId ?? undefined),
  })

export const useSensor = (id?: number) =>
  useQuery({
    queryKey: ['sensor', id],
    queryFn: id ? () => fetchSensor(id) : skipToken,
  })

export const useFridges = (storeId?: number | null) =>
  useQuery({
    queryKey: ['fridges', storeId],
    queryFn: () => fetchFridges(storeId ?? undefined),
    staleTime: 5 * 60 * 1000, // 5 minutes
    placeholderData: keepPreviousData,
  })

export const useFridge = (id?: number) =>
  useQuery({
    queryKey: ['fridge', id],
    queryFn: id ? () => fetchFridge(id) : skipToken,
  })

export const useSensorHistory = (params: FetchSensorHistoryParams) =>
  useQuery({
    queryKey: ['sensorHistory', params.storeId, params.sensorIds, params.startTime, params.endTime],
    queryFn: () => fetchSensorHistory(params),
  })
